import(/* webpackMode: "eager" */ "/vercel/path0/src/app/bankruptcy-law-services-detail-page/page.tsx");
